/**
 * Cart terms gate — CSS :has() enables checkout when the checkbox is checked.
 * JS here is only a safety net for form submit and accelerated checkout clicks.
 */

/** @param {Element | null | undefined} gate */
function hideTermsError(gate) {
  const error = gate?.querySelector('[data-cart-terms-error]');
  if (error) error.hidden = true;
}

/** @param {Element | null | undefined} gate */
function showTermsError(gate) {
  const error = gate?.querySelector('[data-cart-terms-error]');
  if (error) error.hidden = false;
}

/** @param {Element | null | undefined} gate */
function termsAccepted(gate) {
  const checkbox = gate?.querySelector('[data-cart-terms-checkbox]');
  return checkbox instanceof HTMLInputElement && checkbox.checked;
}

/** @param {Event} event */
function onTermsChange(event) {
  const target = event.target;
  if (!(target instanceof HTMLInputElement) || !target.matches('[data-cart-terms-checkbox]')) return;
  const gate = target.closest('[data-cart-terms-gate]');
  if (termsAccepted(gate)) hideTermsError(gate);
}

/** @param {Event} event */
function onCartFormSubmit(event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || form.id !== 'cart-form') return;

  const gate = form.closest('cart-items-component')?.querySelector('[data-cart-terms-gate]');
  if (!gate || termsAccepted(gate)) return;

  event.preventDefault();
  event.stopPropagation();
  showTermsError(gate);
  gate.querySelector('[data-cart-terms-checkbox]')?.focus();
}

/** @param {Event} event */
function onAcceleratedCheckoutClick(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const accelerated = target.closest('.additional-checkout-buttons');
  if (!accelerated) return;

  const gate = accelerated.closest('[data-cart-terms-gate]');
  if (!gate || termsAccepted(gate)) return;

  event.preventDefault();
  event.stopPropagation();
  showTermsError(gate);
  gate.querySelector('[data-cart-terms-checkbox]')?.focus();
}

document.addEventListener('change', onTermsChange);
document.addEventListener('submit', onCartFormSubmit, true);
document.addEventListener('click', onAcceleratedCheckoutClick, true);
